
import { Component, Vue } from "vue-property-decorator";
import Logo from "@/components/Logo.vue";

@Component({
  components: { Logo },
  computed: {},
})
export default class PageNotFoundView extends Vue {}
